export default __webpack_public_path__ + "static/media/fridge-1.e3b01e5d.jpg";